/* eslint-disable react/jsx-key */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  HomeOutlined,
  AccountBookOutlined,
  ContactsOutlined, MinusCircleFilled, UserOutlined, SettingOutlined,
  DisconnectOutlined,
} from '@ant-design/icons';
import {
  Menu, Layout,
} from 'antd';
import H3Image from '@Uilib/h3Image';
import { S3_FILE_URL } from '@Apis/constants';
import TenantActions from '@Actions/tenantActions';
import UserActions from '@Actions/userActions';
import logo from '../../../media/images/logo-without-tagline.png';
import './style.scss';
import { faCircleMinus, faGear, faHandshake, faHouse, faLinkSlash, faTags, faUser, faUserTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { Sider } = Layout;

/**
 *
 */
class UserMenuAdmin extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      openKeys: [],
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      getOrg, user,
    } = this.props;
    getOrg(user?.tenant_info?.org_id);
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.userReady) {
      props.getTenantsConfiguration(props.user?.tenant_info?.tenant_id);
      return {
        ...state,
        userReady: true,
        currentPage: props?.history?.location?.pathname,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      user, org,
      tenantsConfiguration,
    } = this.props;
    const {
      currentPage, collapse, openKeys,
    } = this.state;
    return (
      <Fragment>
        <div className="user-menu-fixed">
          {
            <div style={{
              backgroundColor: 'white',
              zIndex: '10',
              position: 'fixed',
              width: '229px',
              marginTop: '-2px',
            }} onClick={() => history.push('/')}>
              {!user?.tenant_info?.global_config?.settings?.white_label_platform ? (
                <div className="user-menu__logo-fixed">
                  {/* <img src="/favicon.ico" alt="Favicon" className="user-menu__logo" /> */}
                  <div className="user-menu__logo-image-right-wrapper">
                    <H3Image
                      src={logo}
                      className="user-menu__logo-image-right"
                    />
                  </div>
                </div>
              ) : (
                <div className="user-menu__logo-wl-fixed">
                  <div className="user-menu__logo-image-left-wrapper">
                    <H3Image
                      src={org?.organisation?.[0]?.logo}
                      className="user-menu__logo-image-left-mg__26 "
                    />
                  </div>
                  <div className="user-menu__logo-image-right-wrapper">
                    <div
                      className="user-menu__logo-image-right-header"
                    >
                      Powered by
                    </div>
                    <H3Image
                      src={logo}
                      className="user-menu__logo-image-right"
                    />
                  </div>
                </div>
              )}
            </div>
            }
          <Sider
            width="230px"
            style={{height: '100dvh', marginTop: '50px'}}
            onCollapse={() => this.setState({ collapse: !collapse })}
          >
            
            <div style={{marginTop: '25px'}}>
              <Menu
                selectedKeys={[currentPage]}
                defaultSelectedKeys={['/admin/business-units']}
                theme="light"
                openKeys={openKeys}
                onClick={(value) => {
                  const { history } = this.props;
                  history.push(value.key);
                  this.setState({ currentPage: value.key });
                }}
                mode="inline"
                style={{marginTop: '8px'}}
              >
                <Menu.Item key="/admin/business-units" icon={<FontAwesomeIcon icon={faHouse} />}>Business Units</Menu.Item>
                <Menu.Item key="/admin/users" icon={<FontAwesomeIcon icon={faUser} />}>Users</Menu.Item>
                <Menu.Item key="/admin/inventory" icon={<FontAwesomeIcon icon={faTags} />}>Inventory</Menu.Item>
                <Menu.Item key="/admin/vendors" icon={<FontAwesomeIcon icon={faHandshake} />}>Vendors</Menu.Item>
                <Menu.Item key="/admin/customers" icon={<FontAwesomeIcon icon={faUserTag} />}>Customers</Menu.Item>
                <Menu.Item key="/admin/configuration" icon={<FontAwesomeIcon icon={faGear} />}>Configuration</Menu.Item>
                <Menu.Item key="/admin/integration" icon={<FontAwesomeIcon icon={faLinkSlash} />}>Integrations</Menu.Item>
                <Menu.Item key="/" icon={<FontAwesomeIcon icon={faCircleMinus} />}>Exit Admin</Menu.Item>
              </Menu>
            </div>
          </Sider>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers, TenantReducers }) => ({
  user: UserReducers.user,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
  org: UserReducers.org,
});

const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId)),
  getTenantsConfiguration: (tenantId) => dispatch(TenantActions.getTenantsConfiguration(tenantId)),
  getOrg: (orgId) => dispatch(UserActions.getOrg(orgId)),

});

UserMenuAdmin.propTypes = {
  user: PropTypes.any,
  org: PropTypes.any,
  history: PropTypes.any,
  tenantsConfiguration: PropTypes.any,
  getTenantsConfiguration: PropTypes.func,
  getOrg: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserMenuAdmin));
